import { veilGradient } from "src/config/images";

// ФОТОГРАФИЯ ЗА БЛОКОМ — ВО ВСЮ ШИРИНУ ЭКРАНА.
//
// Раньше фон жил внутри блока: у «О нас» и «Частых вопросов» — прямо в
// скруглённой карточке, у остальных — по ширине колонки текста. Получались
// картинки-плашки внутри страницы, каждая в своей рамке. Теперь слой
// вырывается из колонки на всю ширину окна (`w-screen` плюс сдвиг на
// половину), как первый экран: фотография идёт от края до края, а текст
// лежит на ней. Разрешает это `body { overflow-x: hidden }` в
// src/index.css — без него 100vw дал бы горизонтальную прокрутку на
// компьютере с видимым скроллбаром.
//
// Адрес фотографии берётся из SECTION_IMAGES в src/config/images.js, пустое
// значение означает «фона нет»: тогда вместо картинки рисуется мягкое
// свечение (GLOW ниже) — блок не проваливается в плоскую темноту, но и
// страница не превращается в сплошную стену из фотографий.
//
// Как поменять фон — расписано в docs.md, раздел «Фоны секций», и коротко в
// самом конфиге. Программист для этого не нужен: файл кладётся в
// public/backgrounds/, в конфиге пишется его имя.
//
// ЧТО ДЕЛАЕТ С КАДРОМ:
//   · растворяет верх и низ (photo-fade-both) — фотография не обрывается
//     линией и мягко переходит в тёмный фон страницы и в соседний блок;
//   · кладёт сверху тёмную вуаль, плотность которой задаётся одним
//     параметром PHOTO_VEIL на весь сайт;
//   · выходит за верх и низ блока (BLEED) — кадр становится выше, обрезается
//     меньше, а его края растворяются за пределами текста.
//
// ПРО ОБРЕЗКУ. Кадр всегда закрывает слой целиком (object-cover): иначе по
// бокам оставались бы пустые поля, а вуаль ложилась бы на пустоту. Слой
// широкий и низкий, поэтому у снимка 3:2 срезается верх и низ — кладите
// панорамные кадры, ~2:1 и шире, тогда срезать почти нечего.
//
// Родителю нужны `relative` и вертикальные отступы (иначе фотография будет
// ровно по высоте текста), содержимому — `relative`, иначе фон ляжет поверх.

// Мягкое тёплое свечение — то, что видно, пока фотография не выбрана.
// Ровный тёмный фон под блоком за блоком читается как провал: глазу не за что
// зацепиться, и секции сливаются в одну тёмную ленту. Этот еле заметный ореол
// (6% акцентного цвета) даёт объём, не мешая тексту и не требуя ни одного
// килобайта картинок. Меняется вместе с сезоном — цвет берётся из палитры.
const GLOW =
  "radial-gradient(75% 65% at 50% 30%, rgb(var(--kj-gold) / 0.11), transparent 72%)," +
  "radial-gradient(65% 55% at 12% 95%, rgb(var(--kj-sky) / 0.08), transparent 75%)";

// На сколько слой выходит за верх и низ блока.
const BLEED = "-top-12 -bottom-12 sm:-top-16 sm:-bottom-16";

// Выход из колонки текста на всю ширину окна.
const FULL_WIDTH = "left-1/2 w-screen -translate-x-1/2";

export default function SectionBackdrop({ image, className = "" }) {
  const box = `pointer-events-none absolute ${BLEED} ${FULL_WIDTH}`;

  // Фотографии нет — рисуем свечение. Оно ничего не грузит и не мешает клику.
  if (!image) {
    return (
      <div
        aria-hidden="true"
        className={`${box} ${className}`}
        style={{ backgroundImage: GLOW }}
      />
    );
  }

  return (
    <div
      aria-hidden="true"
      className={`${box} overflow-hidden photo-fade-both ${className}`}
    >
      {/* Точка кадрирования выше середины: у пейзажа главное обычно вверху
          (горы, небо, кроны), поэтому при срезе жертвуем низом. */}
      <img
        src={image}
        alt=""
        className="h-full w-full object-cover"
        style={{ objectPosition: "center 35%" }}
      />
      <div className="absolute inset-0" style={{ backgroundImage: veilGradient() }} />
    </div>
  );
}
